<template>
<div class="chapter">
<div class="inner_page">
<div class="title" id="tit01"><a id="page05">
<h2 class="titlePageTitle"><span class="bold">LOST IN THE CITY</span></h2>
<p class="titlePageSubtitle"><span class="bold">STORIES</span></p>
<h2 class="titlePageAuthor"><span class="bold">Edward P. Jones</span></h2>
<p class="image"><img alt="" src="logo.jpg"/></p>
</a><a id="page06"> </a><a id="page07"> </a><a id="page08"> </a><a id="page09"></a></div><a id="page09">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780061748714_title.vue?71e4fb41